function cap_excerpts() {
  if (!document.querySelector('.post-grid .grid-item')) {
    return;
  }

  const gridItems = document.querySelectorAll('.post-grid.has_excerpt .grid-item, body.archive.tag .post-grid .grid-item, body.archive.category .post-grid .grid-item');

  gridItems.forEach((item) => {
    const excerpt = item.querySelector('.excerpt');
    let excerptInner = excerpt.innerText;
    //const linkTarget = item.querySelector('h4 a').getAttribute('href');
    const maxLength = 140;

    excerptInner = excerptInner.substring(0, maxLength);
    excerptInner = excerptInner.substring(0, Math.min(excerptInner.length, excerptInner.lastIndexOf(" ")));
    excerpt.innerHTML = excerptInner + '<span class="follow-up" style="margin-left: 0.25rem;">...</span>';
  });
}
